import React from 'react';
import { useIntl } from 'react-intl';
import { PartDTO } from '../../models/Parts/PartDTO';
import '../../styles/PartCard.css';

export type PartCardProps = {
    part: PartDTO;
    onSelect: () => void;
    disabled: boolean;
    isSelected?: boolean;
};

export const PartCard: React.FC<PartCardProps> = ({
    part,
    onSelect,
    disabled,
    isSelected = false,
}) => {
    const intl = useIntl();

    return (
        <div
            className={`part-card ${isSelected ? 'part-card--selected' : ''}`}
            onClick={disabled ? undefined : onSelect}
            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
        >
            <div className="part-card__code-container">
                <div className="part-card__code">
                    {part.erpId}
                </div>
                {isSelected && (
                    <div className="part-card__check">
                        ✓
                    </div>
                )}
            </div>
            <div className="part-card__name">
                {part.name}
            </div>
        </div>
    );
};
